import ListView from 'antd-mobile/lib/list-view';
export default ListView;



// WEBPACK FOOTER //
// ./components/list-view/index.tsx